import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { affiliationTypesOptions } from "../../../utils/actors";
import { ContentContainer } from '../../../components/Filters/components/ContentContainer';
import { ControlsPanel } from '../../../components/Filters/components/ControlsPanel';
import { CheckboxList } from '../../../components/Filters/components/CheckboxList';
import { useSearchContext } from '../contexts';

export const AffiliationTypesChooser = () => {
  const { t } = useTranslation();
  const { state, updateDraftFilters } = useSearchContext();

  const options = affiliationTypesOptions(t);
  const selected = state.draftFilters.affiliationTypes.value;

  const handleSelectAll = () => {
    updateDraftFilters({
      affiliationTypes: {
        value: options.map(o => o.value),
        exclude: state.draftFilters.affiliationTypes.exclude,
      },
    });
  };

  const handleClearAll = () => {
    updateDraftFilters({
      affiliationTypes: { value: [], exclude: false },
    });
  };

  const handleToggle = (val: string) => {
    const next = selected.includes(val)
      ? selected.filter(v => v !== val)
      : [...selected, val];
    updateDraftFilters({
      affiliationTypes: {
        value: next,
        exclude: state.draftFilters.affiliationTypes.exclude,
      },
    });
  };

  const checkboxItems = useMemo(
    () =>
      options.map(opt => ({
        name: opt.label,
        checked: selected.includes(opt.value),
        onChange: () => handleToggle(opt.value),
        disabled: false,
        icon: null,
      })),
    [options, selected],
  );

  return (
    <ContentContainer
      actionsComponent={
        <ControlsPanel
          id="affiliation-types-filter"
          count={selected.length}
          isExclude={state.draftFilters.affiliationTypes.exclude}
          isSelectAllDisabled={selected.length === options.length}
          showExcludeSwitch={true}
          showSelectAll={true}
          onClearAll={handleClearAll}
          onSelectAll={handleSelectAll}
          onExcludeClick={() => {
            updateDraftFilters({
              affiliationTypes: {
                value: selected,
                exclude: !state.draftFilters.affiliationTypes.exclude,
              },
            });
          }}
        />
      }
    >
      <CheckboxList items={checkboxItems} />
    </ContentContainer>
  );
};
